export default __webpack_public_path__ + "static/media/CaseAcceptance.babcb4ce.png";